"use client"

import React from 'react';
import styles from "./Prayers.module.scss";
import usePrayersData from "@/utils/hooks/usePrayersData";
import {useAppStore} from "@/store/AppStore";
import {Prayer} from "@/types/Prayers";
import LoginAlert from "@/components/LoginAlert/LoginAlert";

export default function Prayers(params: { currentId?: string }) {
  const {currentId} = params
  const user = useAppStore((state) => state.user);
  const data = usePrayersData(user?.access_token)

  const items = data?.items

  // `opened` deriva direttamente dal prop `currentId` (formato
  // `prayer-<id>`). Niente useState/useEffect: e' classico
  // sync-prop-to-state anti-pattern.
  const opened = currentId?.includes("prayer")
    ? Number(currentId.split("prayer-")[1])
    : undefined

  if (!currentId) return null
  if (!currentId.includes("prayer")) return null
  if (!user) return <LoginAlert/>

  const actives: Prayer[] | undefined = opened ? items?.filter((itm) => {
    return itm.id === opened
  }) : undefined

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.contentWrapper}>
          {actives && actives.at(0) && <div>
            <h2 className={styles.prayerTitle}>{actives?.at(0)?.name}</h2>
            <div dangerouslySetInnerHTML={{__html: String(actives?.at(0)?.content)}}/>
          </div>
          }
        </div>
      </div>
    </div>
  )
}
